import { render, staticRenderFns } from "./LimitModal.vue?vue&type=template&id=bf38847e&scoped=true&"
import script from "./LimitModal.vue?vue&type=script&lang=js&"
export * from "./LimitModal.vue?vue&type=script&lang=js&"
import style0 from "./LimitModal.vue?vue&type=style&index=0&id=bf38847e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf38847e",
  null
  
)

export default component.exports